// extracted by mini-css-extract-plugin
export default {"resultpage":"ResultPage_resultpage__U0AGZ","result":"ResultPage_result__3b1kT"};